export default __webpack_public_path__ + "static/media/stagger1.525ef5df.png";